import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Suspense } from 'react';
import { trpc } from '@/lib/trpc';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { Layout } from './-components/layout';
import { Partners } from './-components/partners';
import { Hero } from './-components/solutions/hero';
import { SolutionTabs } from './-components/solutions/solution-tabs';
import { ValueProps } from './-components/solutions/value-props';
import { SuccessCases } from './-components/solutions/success-cases';
import { TechPartners } from './-components/solutions/tech-partners';

export const Route = createFileRoute('/new/solutions')({
	loader: ({ context }) => {
		// Warm up the two live feeds this page renders: the partner-merchant logos (global stats) and
		// the donation stream behind the hero counter. `prefetchQuery`, not `ensureQueryData` — see the
		// homepage loader for why a floating rejected promise here takes the server process down.
		context.queryClient.prefetchQuery(trpc.portal.getWorldcooGlobalStats.queryOptions());
	},
	component: Component,
});

/** Real partner merchants (logo + live campaign, ordered by amount raised) — same source as the homepage. */
function PartnersSection() {
	const { data: stats } = useSuspenseQuery(trpc.portal.getWorldcooGlobalStats.queryOptions());
	// No connector here: it is drawn to lead into the homepage's next section, not into the success stories.
	return <Partners merchants={stats.partnerMerchants} connector={false} />;
}

function Component() {
	return (
		<Layout>
			<Header />
			<Hero />
			<SolutionTabs />
			<ValueProps />
			<Suspense fallback={<div className="min-h-[600px]" />}>
				<PartnersSection />
			</Suspense>
			<SuccessCases />
			<TechPartners />
			<Footer cta="form" />
		</Layout>
	);
}
